import { ORIGIN } from './origin.js';

/**
 * O caminho público de um ficheiro carregado.
 *
 * As chaves vêm do servidor (`iconKey`, `bannerKey`, anexos) e o Caddy serve
 * tudo em `/uploads`. Passa pelo ORIGIN e não por um caminho relativo porque
 * no shell nativo a página não é servida pelo servidor da API — ver
 * lib/origin.ts.
 */
export function uploadUrl(key: string): string {
  return `${ORIGIN}/uploads/${key}`;
}
